/**
 * Props for the DragOverlay component
 */
interface DragOverlayProps {
  /** Whether this is a document upload (default: false, i.e., image upload) */
  isDocumentUpload?: boolean;
}

/**
 * Drag overlay component for file drop zones
 *
 * Shows when user drags a file over the upload area.
 * Provides visual feedback with instructions and file format info.
 */
export function DragOverlay({ isDocumentUpload = false }: DragOverlayProps) {
  return (
    <div className="bg-secondary border-primary absolute -inset-px flex items-center justify-center rounded-md border border-dashed">
      <div className="text-center">
        <div className="text-muted-foreground text-sm font-medium">
          {isDocumentUpload ? "Dokument hier ablegen" : "Bild hier ablegen"}
        </div>
        <div className="text-muted-foreground/80 text-xs">
          {isDocumentUpload
            ? "PDF, PNG, JPG, GIF, WEBP bis 3MB"
            : "PNG, JPG, GIF, WEBP bis 3MB"}
        </div>
      </div>
    </div>
  );
}
